@if (isActive$ | async) {
  @if (title) {
    <div>
      <h1 class="top-0 py-4 py-44 text-center font-accent text-4.5xl font-bold text-neutral-800">
        {{ title }}
      </h1>
    </div>
  }
  <div
    class="mx-auto px-5"
    [class.h-full]="fillHeight"
    [class.md:pt-32]="topPadding === 'auto' && !title"
    [class.pt-8]="topPadding === 'small'"
    [class.pt-16]="topPadding === 'medium'"
    [class.pt-32]="topPadding === 'large'"
    [class.pt-44]="topPadding === 'xlarge'"
  >
    <app-block-list
      [blockIdList]="items"
      [injectData]="{ formId: blockId }"
      class="flex flex-col gap-28"
      [class.pb-52]="bottomPadding === 'auto'"
      [class.pb-8]="bottomPadding === 'small'"
      [class.pb-16]="bottomPadding === 'medium'"
      [class.pb-32]="bottomPadding === 'large'"
      [class.pb-44]="bottomPadding === 'xlarge'"
    ></app-block-list>
  </div>
}
